import "./styles.scss";

const Image = ({
  alt = "",
  filename,
  onClick = () => {},
  title = "",
  className = "",
  imageClassName = "",
}) => {
  const fullFilePath = "https://yurqua.github.io/rbs/docs/assets/" + filename;
  return (
    <div className={["image-block", className].join(" ").trim()}>
      <picture>
        <source
          srcSet={`${fullFilePath}-140.webp 140w, ${fullFilePath}-200.webp 200w, ${fullFilePath}-300.webp 300w, ${fullFilePath}-600.webp 600w, ${fullFilePath}-1000.webp 1000w`}
          sizes="(max-width: 512px), (max-width: 768px), (max-width: 1024px), (max-width: 1280px), (max-width: 1600px), 24vw"
          type="image/webp"
        />
        <source
          srcSet={`${fullFilePath}-140.jpg 140w, ${fullFilePath}-200.jpg 200w, ${fullFilePath}-300.jpg 300w, ${fullFilePath}-600.jpg 600w, ${fullFilePath}-1000.jpg 1000w`}
          sizes="(max-width: 512px), (max-width: 768px), (max-width: 1024px), (max-width: 1280px), (max-width: 1600px), 24vw"
          type="image/jpeg"
        />
        <img
          src={`${fullFilePath}.jpg`}
          className={["img", imageClassName].join(" ").trim()}
          alt={alt}
          title={title}
          onClick={onClick}
        />
      </picture>
    </div>
  );
};
export default Image;
